"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = exports.StyledTextContainer = exports.StyledChip = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const Chip_types_1 = require("./Chip.types");
const fadeIn = (0, styled_components_1.keyframes) `
    0% {opacity: 0;}
    
    100% {opacity: 1;}
`;
exports.StyledChip = styled_components_1.default.div `
  transition: background-color 0.3s ease-in-out !important;
  animation-name: ${fadeIn};
  cursor: pointer;
  display: flex;
  align-items: center;
  height: ${({ height }) => height};
  width: fit-content;
  background-color: ${({ theme, selected }) => selected ? theme.colors.colours.support[100].value : theme.colors.colours.support[20].value};
  padding: 0
    ${({ size, theme }) => {
    if (size === Chip_types_1.ChipSize.XSmall) {
        return theme.sizes['2xs'].value;
    }
    if (size === Chip_types_1.ChipSize.Small) {
        return theme.sizes.xs.value;
    }
    return theme.sizes.s.value;
}};
  ${({ disabled, selected }) => disabled &&
    (0, styled_components_1.css) `
      pointer-events: none;
      cursor: default;
      background-color: ${({ theme }) => theme.colors.colours.system['disable-light-theme'].value};
      opacity: ${selected ? 1 : 0.75};
    `};
  ${({ readOnly, selected }) => readOnly &&
    !selected &&
    (0, styled_components_1.css) `
      pointer-events: none;
      cursor: default;
      background-color: ${({ theme }) => theme.colors.colours.support[20].value};
    `};
  ${({ readOnly, selected }) => readOnly &&
    selected &&
    (0, styled_components_1.css) `
      pointer-events: none;
      cursor: default;
      background-color: ${({ theme }) => theme.colors.colours.support[80].value};
    `};
  ${({ hasButton }) => hasButton &&
    (0, styled_components_1.css) `
      padding-right: 0;
    `};
  button {
    svg {
      transition: all 0.3s ease-in-out !important;
      ${({ selected }) => selected &&
    (0, styled_components_1.css) `
          transition: all 0.3s ease-in-out !important;
          transform: rotate(-45deg);
        `};
    }
  }
`;
exports.StyledTextContainer = styled_components_1.default.div `
  padding-left: ${({ size, theme, hasIcon, hasButton }) => {
    if (hasIcon && !hasButton && size === Chip_types_1.ChipSize.XSmall) {
        return theme.sizes['4xs'].value;
    }
    return hasIcon && !hasButton && theme.sizes['2xs'].value;
}};
  padding-right: ${({ hasButton, theme, size }) => {
    if (hasButton && size === Chip_types_1.ChipSize.XSmall) {
        return theme.sizes['2xs'].value;
    }
    if (hasButton && size === Chip_types_1.ChipSize.Small) {
        return theme.sizes.xs.value;
    }
    return hasButton && theme.sizes.s.value;
}};
  p {
    transition: color 0.3s ease-in-out !important;
    animation-name: ${fadeIn};
  }
`;
exports.StyledIcon = styled_components_1.default.div ``;
//# sourceMappingURL=Chip.styled.js.map